import { useQuery } from "@tanstack/react-query"
import { NotificationGet } from "../app/models/Notification"
import { digitalManagerApi } from "../services/api"

export function useNotifications(getExpired = false) {
  const { data: notificationsList = [], isLoading: isLoadingNotifications } = useQuery({
    queryKey: ["notifications", getExpired],
    queryFn: () =>
      digitalManagerApi
        .get<NotificationGet[]>("/notifications", { params: { expired: getExpired } })
        .then((r) => r.data),
  })

  return {
    notificationsList,
    isLoadingNotifications,
  }
}
